/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Attempt
 */
export interface Attempt {
    /**
     * 
     * @type {number}
     * @memberof Attempt
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof Attempt
     */
    endTime: Date;
    /**
     * 
     * @type {number}
     * @memberof Attempt
     */
    applicant: number;
}

/**
 * Check if a given object implements the Attempt interface.
 */
export function instanceOfAttempt(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "endTime" in value;
    isInstance = isInstance && "applicant" in value;

    return isInstance;
}

export function AttemptFromJSON(json: any): Attempt {
    return AttemptFromJSONTyped(json, false);
}

export function AttemptFromJSONTyped(json: any, ignoreDiscriminator: boolean): Attempt {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'endTime': (new Date(json['end_time'])),
        'applicant': json['applicant'],
    };
}

export function AttemptToJSON(value?: Attempt | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'end_time': (value.endTime.toISOString()),
        'applicant': value.applicant,
    };
}

